import cerrar from "../../assets/vw/svg/cerrar.svg";
import success_icono from "../../assets/vw/svg/check-exito.svg";
import error_icono from "../../assets/vw/svg/check-error.svg";

const Modal = ({ modalInfo, setMostrarModal }) => {
    return (
        <>
            {
                modalInfo.active && (
                    <div
                        className={`modal modal_vw modal_popup_vw fade show`}
                        id="archivar"
                        data-keyboard="false"
                        data-backdrop="static"
                        tabIndex="-1"
                        aria-labelledby="archivarLabel"
                        style={{ display: "block" }}
                        aria-modal="true"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-dialog-centered modal_popup_content">
                            <div className="modal-content modal_content-vw">
                                <div className=" modal_header-vw">
                                    <div className="d-flex justify-content-end m-2">
                                        <button
                                            className="button_icon-vw"
                                            type="button"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => {
                                                setMostrarModal({
                                                    active: false,
                                                    message: '',
                                                    success: false
                                                });
                                            }}
                                        >
                                            <img src={cerrar} alt="cerrar"></img>
                                        </button>
                                    </div>
                                </div>
                                <div className={`modal-body p-3 pt-sm-0`}>
                                    <ModalContenido success={modalInfo.success} mensaje={modalInfo.message} tryAgain={modalInfo.tryAgain} options={modalInfo.options} tryAgainText={modalInfo.tryAgainText}setMostrarModal={setMostrarModal} onclickParam={modalInfo.onclickParam} isDelete={modalInfo.isDelete}/>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

const ModalContenido = ({ success, mensaje, tryAgain, setMostrarModal, onclickParam, tryAgainText, options, isDelete}) => {
    return (
        <div className="mt-0 mt-lg-2 mensaje_confirmacion mb-0 px-5 pb-5 pt-2">
            <div className="d-flex justify-content-center">
                <img
                    src={success ? success_icono : error_icono}
                    className="icono-mensaje"
                    alt="exito"
                ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">{mensaje}</label>
            {(tryAgain && ! success) && (
                <>
                    {options && (
                        <button
                            type="button"
                            className="button_vw button_vw--secondary mr-2 mb-2 order-2 order-sm-1 mt-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => {
                                setMostrarModal({
                                    active: false,
                                    message: '',
                                    success: false
                                });
                            }}
                        >
                            Cancelar
                        </button>
                    )}
                    <button
                        type="button"
                        className={`button_vw ${isDelete ? "button_vw--delete": "button_vw--primary"} mb-2 order-1 order-sm-2 mt-2`}
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            if(onclickParam) onclickParam();
                            setMostrarModal({
                                active: false,
                                message: '',
                                success: false
                            });
                        }}
                    >
                        {tryAgainText ? tryAgainText : 'Intentar de nuevo'}
                    </button>
                    
                </>
            )}
        </div>
    )
}

export default Modal